<template>
    <v-container class="ma-0 pa-0">
        <v-row >
            <v-col cols="12">
                <v-progress-linear v-if="loading" color="primary" indeterminate></v-progress-linear>
                <v-form @submit.prevent v-else ref="editForm" v-model="editDangerousOccurrenceValid">
                    <v-row >
                        <v-col cols="12">
                            <v-autocomplete
                                :items="dangerousOccurrenceTypesSite"
                                item-text="Name"
                                item-value="DangerousOccurrenceTypeID"
                                v-model="dangerousOccurrence.DangerousOccurrenceTypeIDSite"
                                :rules="[rules.selectIDRequired]"
                                label="Site"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                :items="dangerousOccurrenceTypesInTheCourseOf"
                                item-text="Name"
                                item-value="DangerousOccurrenceTypeID"
                                v-model="dangerousOccurrence.DangerousOccurrenceTypeIDInTheCourseOf"
                                :rules="[rules.selectIDRequired]"
                                label="In the course of"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete
                                :items="dangerousOccurrenceTypesHumanAnatomicalLocation"
                                item-text="Name"
                                item-value="DangerousOccurrenceTypeID"
                                v-model="dangerousOccurrence.DangerousOccurrenceTypeIDHumanAnatomicalLocation"
                                :rules="[rules.selectIDRequired]"
                                label="Human Anatomical Location"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                clearable
                                maxlength="8000"
                                v-model="dangerousOccurrence.Comment"
                                label="Comment">
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-btn block :color="useCurrentTime ? 'accent' : ''" :disabled="saving" @click="toggleUseCurrentTime()">
                                <span v-if="useCurrentTime">Using Current Time (press to change)</span>
                                <span v-else>Press to use current time</span>
                                <v-icon v-if="useCurrentTime" right>check_circle</v-icon>
                                <v-icon v-else right>close</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="!useCurrentTime">
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="datePickerMenu"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        clearable
                                        v-model="displayDate"
                                        label="Date"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="dangerousOccurrence.Date"
                                    @input="datePickerMenu = false"
                                    :title-date-format="datePickerFormat"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" v-if="!useCurrentTime">
                            <v-menu
                                ref="timePickerMenu"
                                v-model="timePickerMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="dangerousOccurrence.Time"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        clearable
                                        v-model="dangerousOccurrence.Time"
                                        label="Time"
                                        prepend-icon="access_time"
                                        readonly
                                        :rules="[rules.required]"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="timePickerMenu"
                                    v-model="dangerousOccurrence.Time"
                                    format="24hr"
                                    @click:minute="$refs.timePickerMenu.save(dangerousOccurrence.Time)"
                                ></v-time-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row  class="dialog-action-buttons">
                        <!-- <v-flex xs12 md6>
                            <v-btn block color="accent" :disabled="saving" @click="setTimeToNow()">Set time to Now</v-btn>
                        </v-flex> -->
                        <v-col cols="12" md="6">
                            <v-btn block color="error" :disabled="saving" @click="clearAddDangerousOccurrence(true)">Clear</v-btn>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-btn block color="success" :disabled="!editDangerousOccurrenceValid" :loading="saving" @click="saveDangerousOccurrence">Save</v-btn>
                        </v-col>
                        <v-col cols="12" v-if="saveError">
                            <v-alert text type="error">{{ saveError }}</v-alert>
                        </v-col>
                        <v-col cols="12">
                            <success-alert content="Successfully added Dangerous Occurrence" :display="showSaveSuccess"></success-alert>
                        </v-col>
                    </v-row>     
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<style>

</style>

<script>
import validationRules from "../../helpers/validationrules";
import SuccessAlert from "../common/SuccessAlert";
import util from '@/helpers/util';
import constants from 'comunet-btg-utah-repository-shared/constants';

import moment from 'moment';

export default {
    components: {
        SuccessAlert
    },
    props: {
        specimenID: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            dangerousOccurrence: {},
            datePickerMenu: false,
            timePickerMenu: false,
            rules: validationRules.rules,
            editDangerousOccurrenceValid: false,
            showSaveSuccess: false,
            useCurrentTime: true
        };
    },
    computed: {
        loading() {
            return this.$store.state.dailyHusbandryStore.loadingDangerousOccurrenceTypes;
        },
        saving() {
            return this.$store.state.dailyHusbandryStore.savingDangerousOccurrence;
        },
        saveError() {
            return this.$store.state.dailyHusbandryStore.saveDangerousOccurrenceError;
        },
        dangerousOccurrenceTypes() {
            return [...this.$store.state.dailyHusbandryStore.dangerousOccurrenceTypes].sort(util.sortByField("Name"));
        },
        dangerousOccurrenceTypesSite() {
            return this.dangerousOccurrenceTypes.filter(t => t.Type == "Site").sort(util.sortByField("Name"));
        },
        dangerousOccurrenceTypesInTheCourseOf() {
            return this.dangerousOccurrenceTypes.filter(t => t.Type == "In the course of").sort(util.sortByField("Name", ["Other"]));
        },
        dangerousOccurrenceTypesHumanAnatomicalLocation() {
            return this.dangerousOccurrenceTypes.filter(t => t.Type == "Human Anatomical Location").sort(util.sortByField("Name", ["Other"]));
        },
        displayDate: {
            get: function() {
                if (this.dangerousOccurrence && this.dangerousOccurrence.Date) {
                    return moment.utc(this.dangerousOccurrence.Date).format(constants.DATE_FORMAT_NO_TIME);
                }
                
                return "";
            },
            set: function(newValue) {
                this.dangerousOccurrence.Date = newValue;
            }
        }
    },
    methods: {
        datePickerFormat(date) {
            return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
        },
        toggleUseCurrentTime() {
            this.setTimeToNow();

            this.useCurrentTime = !this.useCurrentTime;
        },
        loadDangerousOccurrenceTypes() {
            this.$store.dispatch("dailyHusbandryStore/loadDangerousOccurrenceTypes");
        },
        allowedDates() {
            // no restriction on allowed dates
            return true;
        },
        setTimeToNow() {
            this.dangerousOccurrence.Date = moment().format("YYYY-MM-DD");
            this.dangerousOccurrence.Time = moment().format("HH:mm");
        },
        clearAddDangerousOccurrence(revalidate) {
            // return form to current time, with no comment or type selected
            this.useCurrentTime = true;

            this.dangerousOccurrence = {
                SpecimenID: this.specimenID,
                Date: moment().format("YYYY-MM-DD"),
                Time: moment().format("HH:mm")
            };

            if (this.$refs && this.$refs.editForm) {
                if (revalidate) {
                    this.$refs.editForm.validate();
                }
            }
        },
        saveDangerousOccurrence() {
            // clear the success message
            this.showSaveSuccess = false;

            // if we are using the current time, set the selected time to now right before we save
            if (this.useCurrentTime) {
                this.setTimeToNow();
            }

            var that = this;

            this.$store.dispatch("dailyHusbandryStore/saveDangerousOccurrence", {
                dangerousOccurrence: this.dangerousOccurrence,
                finally: function() {
                    if (that.$store.state.dailyHusbandryStore.saveDangerousOccurrenceError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.clearAddDangerousOccurrence();

                        // this functionality has been removed, because we are now closing the expansion panel when a record has been successfully added
                        // show a success message
                        //that.showSaveSuccess = true;

                        // refresh the data on the husbandry page (in multiple different components)
                        that.$emit("onSaved");
                    }
                }
            });
        }
    },
    created() {
        this.clearAddDangerousOccurrence();
        this.loadDangerousOccurrenceTypes();
    }
};
</script>